import React, { Component } from "react";
import BasicMap from "./basicMap";
import "ol/ol.css";
import "ol-layerswitcher/dist/ol-layerswitcher.css";

class MasterMap extends Component {

   render() {
    return (
       <BasicMap
       handleCapture={this.props.handleCapture}
       results={this.props.results}
       resData={this.props.resData}
       mainMenu={this.props.mainMenu}
       colors={this.props.colors}
       />
      
    );
  }
}
export default MasterMap;
